// core/auth/guards/auth-guard.js (RDARR)
import { useEffect } from 'preact/hooks';
import { html } from '@shared/utils/rendering/html';
import { useAuth } from '../context/authentication-context';
import { AuthConstants } from '../../constants/auth/auth.constants';

export default function withAuthGuard(Wrapped) {
    const Guard = (props) => {
        const ctx = useAuth();
        if (!ctx) {
            console.error('[auth] AuthProvider missing above this route.');
            return html`<div class="error-page">Auth wiring error: missing AuthProvider.</div>`;
        }

        const { ready, isAuthenticated, ensureSession, login } = ctx;

        useEffect(() => {
            (async () => {
                if (!ready) return;
                if (isAuthenticated) return;
                // Try to establish session via relay-exchange once
                const ok = await ensureSession();
                AuthConstants.Debug && console.debug('[auth-guard] ensureSession result:', ok);
                if (!ok) {
                    const returnUrl = location.pathname + location.search + location.hash;
                    login(returnUrl);
                }
            })();
        }, [ready, isAuthenticated, ensureSession, login]);

        if (!ready) {
            return html`<div class="authenticating p-4">
                <h2 class="mb-2">Authenticating your session…</h2>
                <p>Verifying with ERM Portal…</p>
            </div>`;
        }

        if (!isAuthenticated) {
            return html`<div class="redirecting p-4">
                <h2 class="mb-2">Redirecting to sign in</h2>
                <p>Please wait…</p>
            </div>`;
        }

        return html`<${Wrapped} ...${props} />`;
    };

    Guard.displayName = `WithAuthGuard(${Wrapped.displayName || Wrapped.name || 'Component'})`;
    return Guard;
}
